<body>

    <div id="page" class="page">
        <!-- ***site header html start*** -->
        <header id="masthead" class="site-header">
        <!-- header html start -->
        <div class="top-header">
            <div class="container">
                <div class="top-header-inner">
                    <div class="header-contact text-left">
                    <a href="tel:+01977259912">
                        <i aria-hidden="true" class="icon icon-phone-call2"></i>
                        <div class="header-contact-details">
                            <span class="contact-label">For Further Inquires :</span>
                            <h5 class="header-contact-no">+01 (977) 2599 12</h5>
                        </div>
                    </a>
                    </div>
                    <div class="site-logo text-center">
                    <p class="site-title">
                        <a href="index.html">
                            <img src="assets/images/site-logo.png" alt="Logo">
                        </a>
                    </p>
                    </div>
                    <div class="header-icon text-right">
                    <div class="header-search-icon d-inline-block">
                        <a href="#">
                            <i aria-hidden="true" class="fas fa-search"></i>
                        </a>
                    </div>
                    <div class="offcanvas-menu d-inline-block">
                        <a href="#">
                            <i aria-hidden="true" class="icon icon-burger-menu"></i>
                        </a>
                    </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="bottom-header">
            <div class="container">
                <div class="bottom-header-inner d-flex justify-content-between align-items-center">
                    <div class="header-social social-icon">
                    <ul>
                        <li>
                            <a href="https://www.facebook.com" target="_blank">
                                <i class="fab fa-facebook-f" aria-hidden="true"></i>
                            </a>
                        </li>
                        <li>
                            <a href="https://www.twitter.com" target="_blank">
                                <i class="fab fa-twitter" aria-hidden="true"></i>
                            </a>
                        </li>
                        <li>
                            <a href="https://www.youtube.com" target="_blank">
                                <i class="fab fa-youtube" aria-hidden="true"></i>
                            </a>
                        </li>
                    </ul>
                    </div>
                    <div class="navigation-container d-none d-lg-block">
                    <nav id="navigation" class="navigation">
                        <ul>
                            <li class="menu-active">
                                <a href="index.html">Home</a>
                            </li>
                            <li>
                                <a href="about.html">about us</a>
                            </li>
                            <li>
                                <a href="destination.html">destination</a>
                            </li>
                            <li class="menu-item-has-children">
                                <a href="index.html">packages</a>
                                <ul>
                                <li>
                                    <a href="package.html">Packages</a>
                                </li>
                                <li>
                                    <a href="package-offer.html">Package offer</a>
                                </li>
                                <li>
                                    <a href="package-detail.html">Package detail</a>
                                </li>
                                <li>
                                    <a href="cart.html">Cart page</a>
                                </li>
                                <li>
                                    <a href="booking.html">Booking page</a>
                                </li>
                                <li>
                                    <a href="confirmation.html">Confirmation</a>
                                </li>
                                </ul>
                            </li>
                            <li class="menu-item-has-children">
                                <a href="index.html">Pages</a>
                                <ul>
                                <li>
                                    <a href="service.html">Service</a>
                                </li>
                                <li class="menu-item-has-children">
                                    <a href="#">Career</a>
                                    <ul>
                                        <li>
                                            <a href="career.html">Career</a>
                                        </li>
                                        <li>
                                            <a href="career-detail.html">Career detail</a>
                                        </li>
                                    </ul>
                                </li>
                                <li>
                                    <a href="team.html">Tour guide</a>
                                </li>
                                <li>
                                    <a href="gallery.html">Gallery page</a>
                                </li>
                                <li class="menu-item-has-children">
                                    <a href="#">Blog</a>
                                    <ul>
                                        <li>
                                            <a href="blog-archive.html">Blog archive</a>
                                        </li>
                                        <li>
                                            <a href="blog-single.html">blog single</a>
                                        </li>
                                    </ul>
                                </li>
                                <li>
                                    <a href="single-page.html">Single Page</a>
                                </li>
                                <li>
                                    <a href="testimonial.html">Testimonial</a>
                                </li>
                                <li>
                                    <a href="faq.html">Faq Page</a>
                                </li>
                                <li>
                                    <a href="search-page.html">Search Page</a>
                                </li>
                                <li>
                                    <a href="404.html">404 Page</a>
                                </li>
                                <li>
                                    <a href="comming-soon.html">Comming Soon Page</a>
                                </li>
                                </ul>
                            </li>
                            <li>
                                <a href="contact.html">contact us</a>
                            </li>
                        </ul>
                    </nav>
                    </div>
                    <div class="header-btn">
                    <a href="booking.html" class="round-btn">Book Now</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="mobile-menu-container"></div>
        </header>
        <!-- ***site header html end*** -->
        <main id="content" class="site-main">
        <!-- ***Inner Banner html start form here*** -->
        <div class="inner-banner-wrap">
            <div class="inner-baner-container" style="background-image: url(assets/images/img7.jpg);">
                <div class="container">
                    <div class="inner-banner-content">
                    <h1 class="page-title">Single Page</h1>
                    </div>
                </div>
            </div>
        </div>
        <!-- ***Inner Banner html end here*** -->
        <div class="single-page-section">
            <div class="container">
                <figure class="single-feature-img">
                    <img src="assets/images/img16.jpg" alt="">
                </figure>
                <div class="page-content">
                    <h2>Let's build the better world together</h2>
                    <p>Assumenda mattis condimentum morbi ipsam felis orci, urna placeat blandit dictum amet? Leo magni magna sint erat tenetur! Parturient. Explicabo, hendrerit distinctio fugit excepteur consectetur diamlorem? Possimus magnis wisi officiis impedit egestas, curabitur tempor eiusmod fugiat, posuere elit consectetur non dicta adipisicing corporis rerum hymenaeos nam! Dolores expedita massa, bibendum? Vulputate porta odit, pretium quos sequi? Ipsum possimus nesciunt tempora! Harum voluptas commodo laoreet vestibulum. Integer earum dolorem fusce pretium, sociis aliquid? Dicta illo dolor molestias posuere minima iure bibendum? Nec, condimentum laboriosam vulputate venenatis euismod commodo justo, minima voluptatem, nulla ex aliqua unde sollicitudin pellentesque! Labore mus? Vivamus earum.</p>
                    <p>Architecto reprehenderit veniam curae, auctor donec, sapiente! Mus. Vero. Molestiae natus dictumst, deleniti. Consequuntur odit vulputate aliquet mi, sociis litora eaque dolore optio venenatis quos dolore provident mollis, mollis fringilla accusamus sequi cumque pellentesque porttitor tincidunt odit eros do omnis? Voluptas ex ex aliqua auctor habitant! Lobortis, urna. Consequat libero interdum! Cillum! Phasellus autem, temporibus potenti. Sunt architecto sit maecenas! Scelerisque integer incidunt perspiciatis ridiculus nostrud aliquam optio nec quam, non assumenda, iusto iure? Quibusdam rem, doloribus, augue, saepe mi vehicula parturient aliquam eiusmod. Eveniet, quos luctus bibendum saepe ab! Asperiores est sem diamlorem maiores velit! Habitasse sint ex perferendis.</p>
                    <ul>
                    <li>Purus sequi accusamus? Nibh aut perspiciatis, lorem lorem perspiciatis.</li>
                    <li>Dictum? Posuere cumque sed illum facilisis leo illum facilisis.</li>
                    <li>Neque officiis feugiat praesentium qui, aliqua hic commodo praesentium.</li>
                    <li>Asperiores irure class lobortis veritatis, alias sem lobortis veritatis.</li>
                    <li>Ipsum eros quaerat deserunt proin porttitor, fugit ultrices.</li>
                    <li>Volutpat, justo mollit ullamco sagittis duis enim labore, ullamcorper dicta</li>
                    </ul>
                    <p>Sequi sociis leo, interdum eos ipsa pharetra, unde fringilla erat vulputate litora nisl adipisicing primis consectetuer erat aliqua reprehenderit unde accusamus earum sollicitudin voluptatum wisi vulputate deleniti, accusamus, animi rutrum. Labore et! Odit, nunc nostra, excepturi dui netus, euismod pariatur? Proin vivamus diamlorem natoque reprehenderit vivamus diamlorem natpo.</p>
                    <h3>Placerat quaerat curae reiciendis commodi.</h3>
                    <div class="row">
                    <div class="col-md-4">
                        <img src="assets/images/img4.jpg" alt="">
                    </div>
                    <div class="col-md-4">
                        <img src="assets/images/img5.jpg" alt="">
                    </div>
                    <div class="col-md-4">
                        <img src="assets/images/img6.jpg" alt="">
                    </div>
                    </div>
                    <blockquote>
                    <p>Sagittis perferendis? Leo nobis irure egestas excepturi ipsam nascetur elementum, montes. Torquent, soluta, ac nihil.</p>
                    </blockquote>
                </div>
            </div>
        </div>
        </main>
        <!-- ***site footer html start form here*** -->
        <footer id="colophon" class="site-footer footer-primary">
        <div class="top-footer">
            <div class="container">
                <div class="upper-footer">
                    <div class="row">
                    <div class="col-lg-3 col-sm-6">
                        <aside class="widget widget_text">
                            <div class="footer-logo">
                                <a href="index.html"><img src="assets/images/site-logo.png" alt=""></a>
                            </div>
                            <div class="textwidget widget-text">
                                Urna ratione ante harum provident, eleifend, vulputate molestiae proin fringilla, praesentium magna conubia at perferendis, pretium, aenean aut ultrices.
                            </div>
                        </aside>
                    </div>
                    <div class="col-lg-3 col-sm-6">
                        <aside class="widget widget_latest_post widget-post-thumb">
                            <h3 class="widget-title">RECENT POST</h3>
                            <ul>
                                <li>
                                <figure class="post-thumb">
                                    <a href="blog-archive.html"><img src="assets/images/img21.jpg" alt=""></a>
                                </figure>
                                <div class="post-content">
                                    <h6>
                                        <a href="blog-single.html">BEST JOURNEY TO PEACEFUL PLACES</a>
                                    </h6>
                                    <div class="entry-meta">
                                        <span class="posted-on">
                                            <a href="blog-archive.html">February 17, 2022</a>
                                        </span>
                                    </div>
                                </div>
                                </li>
                                <li>
                                <figure class="post-thumb">
                                    <a href="blog-archive.html"><img src="assets/images/img22.jpg" alt=""></a>
                                </figure>
                                <div class="post-content">
                                    <h6>
                                        <a href="blog-single.html">TRAVEL WITH FRIENDS IS BEST</a>
                                    </h6>
                                    <div class="entry-meta">
                                        <span class="posted-on">
                                            <a href="blog-archive.html">February 17, 2022</a>
                                        </span>
                                    </div>
                                </div>
                                </li>
                            </ul>
                        </aside>
                    </div>
                    <div class="col-lg-3 col-sm-6">
                        <aside class="widget widget_text">
                            <h3 class="widget-title">CONTACT US</h3>
                            <div class="textwidget widget-text">
                                <p>Feel free to contact and<br/> reach us !!</p>
                                <ul>
                                <li>
                                    <a href="tel:+01988256203">
                                        <i aria-hidden="true" class="icon icon-phone1"></i>
                                        +01(988) 256 203
                                    </a>
                                </li>
                                <li>
                                    <a href="mailtop:info@domain.com">
                                        <i aria-hidden="true" class="icon icon-envelope1"></i>
                                        info@domain.com
                                    </a>
                                </li>
                                <li>
                                    <i aria-hidden="true" class="icon icon-map-marker1"></i>
                                    3146 Koontz, California
                                </li>
                                </ul>
                            </div>
                        </aside>
                    </div>
                    <div class="col-lg-3 col-sm-6">
                        <aside class="widget">
                            <h3 class="widget-title">Gallery</h3>
                            <div class="gallery gallery-colum-3">
                                <figure class="gallery-item">
                                <a href="assets/images/img10.jpg" data-fancybox="gallery-1">
                                    <img src="assets/images/img21.jpg" alt="">
                                </a>
                                </figure>
                                <figure class="gallery-item">
                                <a href="assets/images/img28.jpg" data-fancybox="gallery-1">
                                    <img src="assets/images/img22.jpg" alt="">
                                </a>
                                </figure>
                                <figure class="gallery-item">
                                <a href="assets/images/img14.jpg" data-fancybox="gallery-1">
                                    <img src="assets/images/img23.jpg" alt="">
                                </a>
                                </figure>
                                <figure class="gallery-item">
                                <a href="assets/images/img15.jpg" data-fancybox="gallery-1">
                                    <img src="assets/images/img24.jpg" alt="">
                                </a>
                                </figure>
                                <figure class="gallery-item">
                                <a href="assets/images/img12.jpg" data-fancybox="gallery-1">
                                    <img src="assets/images/img25.jpg" alt="">
                                </a>
                                </figure>
                                <figure class="gallery-item">
                                <a href="assets/images/img13.jpg" data-fancybox="gallery-1">
                                    <img src="assets/images/img26.jpg" alt="">
                                </a>
                                </figure>
                            </div>
                        </aside>
                    </div>
                    </div>
                </div>
                <div class="lower-footer">
                    <div class="row align-items-center">
                    <div class="col-lg-6">
                        <div class="footer-newsletter">
                            <p>Subscribe our newsletter for more update & news !!</p>
                            <form class="newsletter">
                                <input type="email" name="email" placeholder="Enter Your Email">
                                <button type="submit" class="outline-btn outline-btn-white">Subscribe</button>
                            </form>
                        </div>
                    </div>
                    <div class="col-lg-6 text-right">
                        <div class="social-icon">
                            <ul>
                                <li>
                                <a href="https://www.facebook.com/" target="_blank">
                                    <i class="fab fa-facebook-f" aria-hidden="true"></i>
                                </a>
                                </li>
                                <li>
                                <a href="https://www.twitter.com/" target="_blank">
                                    <i class="fab fa-twitter" aria-hidden="true"></i>
                                </a>
                                </li>
                                <li>
                                <a href="https://www.youtube.com/" target="_blank">
                                    <i class="fab fa-youtube" aria-hidden="true"></i>
                                </a>
                                </li>
                                <li>
                                <a href="https://www.instagram.com/" target="_blank">
                                    <i class="fab fa-instagram" aria-hidden="true"></i>
                                </a>
                                </li>
                                <li>
                                <a href="https://www.linkedin.com/" target="_blank">
                                    <i class="fab fa-linkedin" aria-hidden="true"></i>
                                </a>
                                </li>
                            </ul>
                        </div>
                        <div class="footer-menu">
                            <ul>
                                <li>
                                <a href="policy.html">Privacy Policy</a>
                                </li>
                                <li>
                                <a href="policy.html">Term & Condition</a>
                                </li>
                                <li>
                                <a href="faq.html">FAQ</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="bottom-footer">
            <div class="container">
                <div class="copy-right text-center">Copyright &copy; 2022 Traveler. All rights reserved.</div>
            </div>
        </div>
        </footer>
        <!-- ***site footer html end*** -->
        <a id="backTotop" href="#" class="to-top-icon">
        <i class="fas fa-chevron-up"></i>
        </a>
        <!-- ***custom search field html*** -->
        <div class="header-search-form">
        <div class="container">
            <div class="header-search-container">
                <form class="search-form" role="search" method="get" >
                    <input type="text" name="s" placeholder="Enter your text...">
                </form>
                <a href="#" class="search-close">
                    <i class="fas fa-times"></i>
                </a>
            </div>
        </div>
        </div>
        <!-- ***custom search field html*** -->
        <!-- ***custom top bar offcanvas html*** -->
        <div id="offCanvas" class="offcanvas-container">
        <div class="offcanvas-inner">
            <div class="offcanvas-sidebar">
                <aside class="widget author_widget">
                    <h3 class="widget-title">OUR PROPRIETOR</h3>
                    <div class="widget-content text-center"> 
                    <div class="profile"> 
                        <figure class="avatar"> 
                            <img src="assets/images/img21.jpg" alt=""> 
                        </figure> 
                        <div class="text-content"> 
                            <div class="name-title"> 
                                <h4> James Watson</h4> 
                            </div> 
                            <p>Accumsan? Aliquet nobis doloremque, aliqua? Inceptos voluptatem, duis tempore optio quae animi viverra distinctio cumque vivamus, earum congue, anim velit</p> 
                        </div> 
                        <div class="socialgroup"> 
                            <ul> 
                                <li> <a target="_blank" href="#"> <i class="fab fa-facebook"></i> </a> </li> 
                                <li> <a target="_blank" href="#"> <i class="fab fa-google"></i> </a> </li> 
                                <li> <a target="_blank" href="#"> <i class="fab fa-twitter"></i> </a> </li> 
                                <li> <a target="_blank" href="#"> <i class="fab fa-instagram"></i> </a> </li> 
                                <li> <a target="_blank" href="#"> <i class="fab fa-pinterest"></i> </a> </li> 
                            </ul> 
                        </div> 
                    </div> 
                    </div>
                </aside>
                <aside class="widget widget_text text-center">
                    <h3 class="widget-title">CONTACT US</h3>
                    <div class="textwidget widget-text">
                    <p>Feel free to contact and<br/> reach us !!</p>
                    <ul>
                        <li>
                            <a href="tel:+01988256203">
                                <i aria-hidden="true" class="icon icon-phone1"></i>
                                +01(988) 256 203
                            </a>
                        </li>
                        <li>
                            <a href="mailtop:info@domain.com">
                                <i aria-hidden="true" class="icon icon-envelope1"></i>
                                info@domain.com
                            </a>
                        </li>
                        <li>
                            <i aria-hidden="true" class="icon icon-map-marker1"></i>
                            3146 Koontz, California
                        </li>
                    </ul>
                    </div>
                </aside>
            </div>
            <a href="#" class="offcanvas-close">
                <i class="fas fa-times"></i>
            </a>
        </div>
        <div class="overlay"></div>
        </div>
        <!-- ***custom top bar offcanvas html*** -->
    </div>

</body>